/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PerspectiveIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Perspective',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 3.281v31.276a1 1 0 0 0 1.351.936l30-11.25a1 1 0 0 0 .649-.936V10.781a1 1 0 0 0-.757-.97l-30-7.5A1 1 0 0 0 2 3.281Zm30 12.836-6 .4v-6.5l6 1.446ZM16 17.19V7.613l8 1.929v7.112Zm8 1.356v7.126l-8 2.938v-9.419ZM14 7.131v10.193L4 18V4.72ZM4 20.16l10-.807v9.992L4 33.017Zm22 4.778v-6.554l6-.484v4.834Z"
    />
  </svg>`;
};
